// removed by extract-text-webpack-plugin
module.exports = {"AssetPopupNav__container":"Gk10W90FSkPLz-rlt3VMw","AssetPopupNav":"_2H3DxtRvRmffUSjdUAqoc7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetPopupNav/AssetPopupNav.scss
// module id = 2722
// module chunks = 0